export const TextValidations = {
  URL: 'url',
  TEXT: 'text',
  IPV4: 'ipv-4',
  EMAIL: 'text_email',
  NUMBER: 'text_number',
  TEXT_MATCH: 'text_match',
  ASCII_CHAR: 'ascii_chars',
  NOT_EMPTY: 'text_not_empty',
  ALL_NO_NUM: 'text_all_no_num',
  MIN_ONE_DIGIT: 'text_min_one_digit',
  MIN_CHAR_COUNT: 'text_min_char_count',
  MAX_CHAR_COUNT: 'text_max_char_count',
  NOT_EMPTY_NO_SPACE: 'text_not_empty_no_space',
  NO_CONSECUTIVE_NUMBERS: 'text_consecutive_numbers',
  ONE_LOWER_CHAR_CASE: 'text_min_one_lower_case_char',
  ONE_UPPER_CHAR_CASE: 'text_min_one_upper_case_char',
  MIN_SPECIAL_CHARACTER: 'text_min_special_character_count',
  ALPHA_NUM_WITH_PUNC_CHAR: 'text_alpha_num_with_punc_chars',
  ASCII_CHAR_WITH_RESTRICTION: 'ascii_chars_with_restriction',
  ALL_CHARS_WITH_DOT_AND_SPACE: 'all_chars_with_dot_and_space',
};

export const DateValidations = {
  NOT_EMPTY: 'date_not_empty',
};

// Only generic and world wide same regex will be listed here.
// E.g: One upper case, one lower case, consecutive numbers, etc.
export const Regexs = {
  NUM: /^[0-9]*$/,
  NO_NUM: /^([^0-9]*)$/,
  MIN_ONE_DIGIT: /(?=.*\d)/,
  APLHA_SPACE: /^[a-zA-Z ]*$/,
  CONSECUTIVE_NUMBERS: /(?=(\d{3}))/,
  ONE_LOWER_CHAR_CASE: /(?=.*[a-z])/,
  ONE_UPPER_CHAR_CASE: /(?=.*[A-Z])/,
  TEN_DIGIT_PHONE_NUMBER: /^[1-9][0-9]{9}$/,
  ALL_CHARS_WITH_DOT_AND_SPACE: /^[a-zA-Z .]*$/,
  ASCII: /^[a-zA-Z0-9\s&.()[\]_\-'",!*+|@#?]*$/,
  MIN_SPECIAL_CHARACTER: /[!@#$%^&*(),.?":{}|<>]/,
  ASCII_II: /^[a-zA-Z0-9\s|\-:(),_.[\]&/#+@;'–]*$/,
  EMAIL: /^([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4})*$/,
  ALPHA_NUM_WITH_PUNC_CHAR: /^[ A-Za-z0-9!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~]*$/,
  IPV4: /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/,
  URL: /^(?!www\.)(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9._~:/?#[\]@!$&'()*+,;=%-]+[a-zA-Z0-9._~:/?#[\]@!$&'()*+,;=%-]\.[^\s]{2,}|www\.[a-zA-Z0-9._~:/?#[\]@!$&'()*+,;=%-]+[a-zA-Z0-9._~:/?#[\]@!$&'()*+,;=%-]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9._~:/?#[\]@!$&'()*+,;=%-]+\.[^\s]{2,}|www\.[a-zA-Z0-9._~:/?#[\]@!$&'()*+,;=%-]+\.[^\s]{2,})*$/,
};

export const DefaultRegexMessageMap = {
  [TextValidations.NUMBER]: {
    validation: Regexs.NUM,
    message: 'MSG_VAL_TEXT_NUMBER',
  },
  [TextValidations.ALL_NO_NUM]: {
    validation: Regexs.NO_NUM,
    message: 'MSG_VAL_TEXT_ALL_NO_NUMBER',
  },
  [TextValidations.EMAIL]: {
    validation: Regexs.EMAIL,
    message: 'MSG_VAL_TEXT_EMAIL',
  },
  [TextValidations.TEXT]: {
    validation: Regexs.APLHA_SPACE,
    message: 'MSG_VAL_TEXT',
  },
  [TextValidations.MIN_SPECIAL_CHARACTER]: {
    validation: Regexs.MIN_SPECIAL_CHARACTER,
    message: 'MSG_VAL_TEXT_MIN_SPECIAL_CHAR_COUNT',
  },
  [TextValidations.NO_CONSECUTIVE_NUMBERS]: {
    validation: Regexs.CONSECUTIVE_NUMBERS,
    message: 'MSG_VAL_NO_CONSECUTIVE_NUMBERS',
  },
  [TextValidations.ONE_LOWER_CHAR_CASE]: {
    validation: Regexs.ONE_LOWER_CHAR_CASE,
    message: 'MSG_VAL_ONE_LOWER_CHAR_CASE',
  },
  [TextValidations.ONE_UPPER_CHAR_CASE]: {
    validation: Regexs.ONE_UPPER_CHAR_CASE,
    message: 'MSG_VAL_ONE_UPPER_CHAR_CASE',
  },
  [TextValidations.MIN_ONE_DIGIT]: {
    validation: Regexs.MIN_ONE_DIGIT,
    message: 'MSG_VAL_MIN_ONE_DIGIT',
  },
  [TextValidations.ALL_CHARS_WITH_DOT_AND_SPACE]: {
    validation: Regexs.ALL_CHARS_WITH_DOT_AND_SPACE,
    message: 'MSG_VAL_ALL_CHARS_WITH_DOT_AND_SPACE',
  },
  [TextValidations.IPV4]: {
    validation: Regexs.IPV4,
    message: 'MSG_VAL_IPV4',
  },
  [TextValidations.ALPHA_NUM_WITH_PUNC_CHAR]: {
    validation: Regexs.ALPHA_NUM_WITH_PUNC_CHAR,
    message: 'MSG_ALPHA_NUM_WITH_PUNC_CHAR',
  },
  [TextValidations.ASCII_CHAR]: {
    validation: Regexs.ASCII,
    message: 'MSG_ASCII_CHAR',
  },
  [TextValidations.ASCII_CHAR_WITH_RESTRICTION]: {
    validation: Regexs.ASCII_II,
    message: 'MSG_ASCII_CHAR_WITH_RESTRICTION',
  },
  [TextValidations.URL]: {
    validation: Regexs.URL,
    message: 'MSG_VAL_TEXT_URL',
  },
  [TextValidations.TEXT_MATCH]: {
    validation: '',
    message: 'MSG_VAL_TEXT_MATCH',
  },
  [TextValidations.NOT_EMPTY]: {
    validation: '',
    message: 'MSG_VAL_TEXT_NOT_EMPTY',
  },
  [TextValidations.MIN_CHAR_COUNT]: {
    validation: '',
    message: 'MSG_VAL_TEXT_MIN_CHAR_COUNT',
  },
  [TextValidations.MAX_CHAR_COUNT]: {
    validation: '',
    message: 'MSG_VAL_TEXT_MAX_CHAR_COUNT',
  },
  [TextValidations.NOT_EMPTY_NO_SPACE]: {
    validation: '',
    message: 'MSG_VAL_TEXT_NOT_EMPTY_NO_SPACE',
  },
};
